import React, { useEffect, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import StrapiMedia from "../strapi-media"

const BandSlide = ({ title, subTitle, bands, html = "" }) => {
  const [bandsRender, setBandsRender] = useState([])
  const [activeIndex, setActiveIndex] = useState(1)

  useEffect(() => {
    if (bands) {
      setBandsRender([...bands.data.slice(0, 3)])
    }
  }, [bands])

  const goNext = () => {
    let newBandsRender
    if (activeIndex === bands.data.length - 1) {
      newBandsRender = [bands.data.slice(-1)[0], bands.data[0], bands.data[1]]
    } else if (activeIndex === bands.data.length - 2) {
      newBandsRender = [
        bands.data.slice(-2)[0],
        bands.data.slice(-1)[0],
        bands.data[0],
      ]
    } else {
      newBandsRender = bands.data.slice(activeIndex, activeIndex + 3)
    }
    setBandsRender(newBandsRender)
    setActiveIndex(activeIndex === bands.data.length - 1 ? 0 : activeIndex + 1)
  }

  const goBack = () => {
    let newBandsRender
    if (activeIndex === 1) {
      newBandsRender = [bands.data.slice(-1)[0], bands.data[0], bands.data[1]]
    } else if (activeIndex === 0) {
      newBandsRender = [
        bands.data.slice(-2)[0],
        bands.data.slice(-1)[0],
        bands.data[0],
      ]
    } else {
      newBandsRender = bands.data.slice(activeIndex - 2, activeIndex + 1)
    }
    setBandsRender(newBandsRender)
    setActiveIndex(activeIndex === 0 ? bands.data.length - 1 : activeIndex - 1)
  }

  if (!bands) return <div></div>

  return (
    <div className="mt-32 lg:mb-0 mb-20">
      <div className="max-w-screen-2xl mx-auto">
        <div dangerouslySetInnerHTML={{ __html: title }}></div>
        <div dangerouslySetInnerHTML={{ __html: subTitle }}></div>
        <div className="my-20 px-5 sm:px-10">
          <button
            className="float-right flex flex-row items-center cursor-pointer"
            onClick={() => goNext()}
          >
            <span className="font-semibold font-syne sm:font-syne--22 leading-none mr-2">
              Larger Band
            </span>
            <StaticImage
              src="../../static/images/icon/angle-arrow-right.svg"
              alt="arrow-right"
            />
          </button>
          <button
            className="flex flex-row items-center cursor-pointer"
            onClick={() => goBack()}
          >
            <StaticImage
              src="../../static/images/icon/angle-arrow-left.svg"
              alt="arrow-left"
            />
            <span className="font-semibold font-syne sm:font-syne--22 leading-none ml-2">
              Smaller Band
            </span>
          </button>
        </div>
      </div>
      <div className="max-w-screen-2xl mx-auto overflow-hidden 2xl:overflow-visible">
        <div className="relative flex flex-row w-[120%] left-[-10%]">
          {bandsRender.map((band, index) => {
            const { htmlTitle, description, content, image } = band.attributes
            return (
              <div
                key={title + content}
                className={`lg:inline-block py-5 ${
                  index === 1
                    ? "w-2/3 mx-auto block border-l border-r lg:w-[38%]"
                    : "hidden transform lg:w-[31%]"
                }`}
              >
                <div className="px-10">
                  {image && (
                    <div className="lg:h-[320px] h-auto flex items-end max-h-full">
                      <StrapiMedia image={image} />
                    </div>
                  )}
                  {htmlTitle && (
                    <div
                      className="font-cardo my-5 text-center"
                      dangerouslySetInnerHTML={{ __html: htmlTitle }}
                    ></div>
                  )}
                  <div
                    className="font-semibold my-5"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></div>
                  <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
      <div className="max-w-screen-reds-2xl m-auto px-7 pt-20">
        <div className="w-full border-b"></div>
      </div>
    </div>
  )
}

export default BandSlide
